import { render, staticRenderFns } from "./OnlineConsultation.vue?vue&type=template&id=eeebb676"
import script from "./OnlineConsultation.vue?vue&type=script&lang=js"
export * from "./OnlineConsultation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports